import { NgTemplateOutlet } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

@Component({
  selector: 'rma-anchor-or-div',
  templateUrl: './anchor-or-div.component.html',
  imports: [RouterModule, NgTemplateOutlet],
})
export class AnchorOrDivComponent {
  @Input() url?: string;
  @Input() routerLink?: string;
  @Input() relativeTo?: ActivatedRoute | null = undefined;
}
